// 从系统字体迁移到 Shopify CDN 字体
// 优化目标：使用统一的 Mont 字体，通过 Cloudflare CDN 加速

// Shopify CDN 字体配置
const SHOPIFY_CDN_BASE = 'https://cdn.shopify.com/s/files/1/1924/1075/files'
const FONT_VERSION = '1766027555'

// 字体 URL 映射
export const fontUrls = {
  book: `${SHOPIFY_CDN_BASE}/MontForAnker-Book.woff2?v=${FONT_VERSION}`,
  regular: `${SHOPIFY_CDN_BASE}/MontForAnker-Regular.woff2?v=${FONT_VERSION}`,
  semibold: `${SHOPIFY_CDN_BASE}/MontForAnker-SemiBold.woff2?v=${FONT_VERSION}`,
  bold: `${SHOPIFY_CDN_BASE}/MontForAnker-Bold.woff2?v=${FONT_VERSION}`,
  heavy: `${SHOPIFY_CDN_BASE}/MontForAnker-Heavy.woff2?v=${FONT_VERSION}`,
}

// 生成 @font-face CSS
export const fontFaceStyles = `
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.book}') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.regular}') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.semibold}') format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.semibold}') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.bold}') format('woff2');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Mont';
    src: url('${fontUrls.heavy}') format('woff2');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`

// CSS 变量定义
export const fontVariables = `
  :root {
    --font-mont: 'Mont', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .font-mont {
    font-family: var(--font-mont);
  }
`
